export default {
  namespaced: true,

  state: {
    extensions: [
      /*
            {
                name: 'my-example',
                url: '/my-example.min.js',
                component: 'my-example',
                settings: {
                    name: 'Test',
                },
            },
            */
    ],
  },

  getters: {
    extensions(state) {
      return state.extensions || []
    },
  },
}
